// extracted by mini-css-extract-plugin
export default {"selectScreen":"SelectScreen_selectScreen__afwAL","selectContainer":"SelectScreen_selectContainer__xjlgG","button":"SelectScreen_button__WxhKX"};